<template>
  <svg
    class="icon fill-current"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M10.7106 1.29289C10.3182 0.902369 9.6818 0.902369 9.28935 1.29289L5.28935 5.29289C4.89882 5.68342 4.89882 6.31658 5.28935 6.70711C5.67987 7.09763 6.31304 7.09763 6.70356 6.70711L9 4.41073V13C9 13.5523 9.44771 14 10 14C10.5523 14 11 13.5523 11 13V4.41073L13.2964 6.70711C13.687 7.09763 14.3201 7.09763 14.7106 6.70711C15.1012 6.31658 15.1012 5.68342 14.7106 5.29289L10.7106 1.29289ZM4 8C4.55229 8 5 8.44772 5 9V15C5 15.5523 5.44772 16 6 16H14C14.5523 16 15 15.5523 15 15V9C15 8.44772 15.4477 8 16 8C16.5523 8 17 8.44772 17 9V15C17 16.6569 15.6569 18 14 18H6C4.34315 18 3 16.6569 3 15V9C3 8.44772 3.44772 8 4 8Z"
    />
  </svg>
</template>

<script>
export default {
  name: 'IOSShareIcon'
}
</script>
